import { Brain, Lightbulb, Rocket } from "lucide-react";
import { Reveal } from "@/lib/motion";

const PILLARS = [
  {
    icon: Brain,
    num: "I",
    title: "Artificial Intelligence",
    body: "We build on modern AI as a core capability, not a feature. Intelligence is engineered into the foundation of everything we create.",
  },
  {
    icon: Lightbulb,
    num: "II",
    title: "Product Innovation",
    body: "We design products that feel obvious in hindsight, removing friction between an idea and a working, launchable result.",
  },
  {
    icon: Rocket,
    num: "III",
    title: "Real-World Utility",
    body: "Every product must earn its place by creating tangible value, helping people ship real software, businesses, and opportunities.",
  },
];

export const HowWeBuild = () => (
  <section id="how" data-testid="how-section" className="relative py-28 sm:py-40">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl mb-16">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-violet-300/80">
            04 — How We Build
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-500 tracking-[-0.02em] text-white">
            Three pillars behind every product.
          </h2>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-5">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1}>
            <div
              data-testid={`pillar-${i}`}
              className="glass glass-hover group relative h-full rounded-3xl p-8 overflow-hidden"
            >
              <span className="absolute top-6 right-7 font-display text-5xl font-600 text-white/[0.04] group-hover:text-violet-400/10 transition-colors duration-500">
                {p.num}
              </span>
              <div className="mb-7 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-gradient-to-br from-violet-500/15 to-cyan-500/10 text-violet-200">
                <p.icon size={22} strokeWidth={1.5} />
              </div>
              <h3 className="font-display text-xl font-600 text-white">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/50 font-light">
                {p.body}
              </p>
              <div className="mt-8 h-px w-full bg-gradient-to-r from-violet-400/30 to-transparent scale-x-0 origin-left transition-transform duration-500 group-hover:scale-x-100" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
